<template>
  <div class="p-12">
    <template v-for="v in visibleFields" :key="v.key">
      <div class="m-b-15 s_flex_ali" style="color:#131313;">
        <template v-if="v.key!='enterpriseInfo'">
          <div class="label">{{v.label}}：</div>
          <div class="content  " style="">
            <img v-if="v.key=='enterpriseLogo'" src="@/assets/images/normal.png" alt="企业Logo" class="width-50 height-50">
            <template v-else>
              {{v.defaultText}}
              <PhoneFilled v-if="v.key=='enterprisePhone' && showCall" :style="{ color: gobleStyle.themeColor }" />
            </template>
          </div>
        </template>
        <div v-else class="s_flex_ali">
          <div v-if="v.customerTitle" class="label">{{v.label}}：</div>
          <img src="@/assets/images/normal.png" alt="" class="width-50 height-50 m-r-10">
          <div>
            <div class="s_font_b fz-14">xxxxxxx有限公司</div>
            <div class="s_flex_ali">
              <span v-if='data.params.is_show_phone'>400-8381186</span>  <div class="m-l-20 fz-12 text-ac themeColor " :style="'color:'+gobleStyle.themeColor+';border-color:'+gobleStyle.themeColor" v-if='showCall && data.params.is_show_phone'>
                <PhoneFilled />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import { PhoneFilled } from "@ant-design/icons-vue";
import { computed } from 'vue';
import { enterprisePreviewFields } from '../../traceFields';
export default {
  props: { data: Object,gobleStyle:Object },
  components: {PhoneFilled},
  setup(props) {
    return {
      visibleFields: computed(() => enterprisePreviewFields(props.data).filter(
        (field) => field.key !== 'enterprisePhone' || props.data.params.is_show_phone !== false
      )),
      showCall: computed(() => props.data.params.is_show_call === true || props.data.params.is_show_call == 1),
    };
  },
};
</script>

<style lang="less" scoped>
.label {
  font-size: 14px;
  font-weight: bold;
  margin-right: 10px;
}
.content {
  flex: 1;
}
.videoContent {
  position: relative;
  &::before {
    content: "";
    background-image: url("../../../../../../../../assets/images/scan/play.png");
    background-size: cover;
    width: 20px;
    height: 20px;
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>


